import React, { Fragment, useEffect, useState } from 'react';
import { openReport } from '../../../utils/sessionGuard'; // セッション失効時は新タブを開かず現在の画面でログインへ
import {
  Typography,
  Button,
  Form,
  message,
  Card,
  Input,
  Select,
  Tabs,
  Radio,
  Space,
  Row,
  Col,
  Modal,
  TreeSelect,
  Spin,
} from 'antd';
import Axios from 'axios';
import config from '../../Config/key';
import { useSelector } from 'react-redux';
import CheckboxMenu from './CheckboxMenu';
import { CarryOutOutlined } from '@ant-design/icons';
import {
  filterAccessibleSeasons,
  noAccessibleSeasonMessage,
} from '../../../utils/seasonFilter';
// 組織情報管理（確定組織表）連携: シーズン開始日時点の部署ソースへ切替（Ph.4）
import {
  DEPT_TREE_SELECT_PROPS,
  buildDepartmentTree,
} from '../../../utils/orgReportFilter';
// 系列会社ありグループの系列会社 Select・系列会社別の部署ソース（「グループ会社・系列会社構造」PJ Ph.4b）
import { resolveCompanyRule } from '../../../utils/companyRule';
import {
  COMPANY_ALL_VALUE,
  fetchDeptPathsForCompany,
  parseCompanyQualifiedPaths,
  companyChoices,
  normalizeCompanySelection,
  companyScopePaths,
  pathsWithinScopes,
  toYmdDash,
} from '../../../utils/companyDeptSource';
import CompanySelectBlock from './CompanySelectBlock';
const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;
let dpObj = {
  //所属部署の全ての経路を含むリスト、段階別に区別
  dp1: [],
  dp2: [],
  dp3: [],
  dp4: [],
  dp5: [],
};
let dpText = {
  //所属部署の全ての経路を含むリスト、段階別に区別
  dp1: '',
  dp2: '',
  dp3: '',
  dp4: '',
  dp5: '',
};

const PDF30010DowlnoadPage = () => {
  const [groups, setGroups] = useState([]); //グループ名とグループコード
  const [selGroupInfo, setSelGroupInfo] = useState([]); //選択されたグループ情報
  const [selGroupDepartment, setSelGroupDepartment] = useState([]); //選択されたグループの部署のRadio Option、第一部署
  const [depArr, setDepArr] = useState([]); //選択されたグループの部署配列、第一部署
  const [selGroupDepartmentLong, setSelGroupDepartmentLong] = useState([]); //選択されたグループの部署のRadio Option、Full
  const [depArrLong, setDepArrLong] = useState([]); //選択されたグループの部署配列、Full
  const [selGroupCode, setSelGroupCode] = useState(''); //選択されたグループコード
  const [survey, setSurvey] = useState([]); //全てのサーベイ情報
  const [questionSet, setQuestionSet] = useState([]); //全てのサーベイ情報
  const [selQuestionSetId, setSelQuestionSetId] = useState(''); //全てのサーベイ情報
  const [selSurveyInfo, setSelSurveyInfo] = useState([]); //選択されたサーベイ情報
  const [groupSurveySeasonInfo, setGroupSurveySeasonInfo] = useState([]); //選択されたグループに存在するサーベイシーズン
  const [selSurveySeasonInfo, setSelSurveySeasonInfo] = useState([]); //選択されたサーベイシーズン情報
  const [selSurveySeasonId, setSelSurveySeasonId] = useState(''); //選択されたサーベイシーズンID
  const [submitSW, setSubmitSW] = useState(true); //SubmitボタンDisable調整 true => 表示
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [positionArr, setPositionArr] = useState([]);
  const [levelCodeArr, setLevelCodeArr] = useState([]);
  const [goOutArr, setGoOutArr] = useState([]);
  const [depAll, setDepAll] = useState(0); //詳細、部署選択、0:全体、1:部署選択
  const [treeData, setTreeData] = useState([]);
  const [selTree, setSelTree] = useState('');
  // 確定組織表を使用中の場合の基準日（'YYYY-MM-DD'）。空なら Group.department（従来）を使用中。
  const [orgNoticeDate, setOrgNoticeDate] = useState('');
  // 系列会社 Select（系列会社ありグループのみ表示。'' = 全社（グループ全体））
  const [companyNames, setCompanyNames] = useState([]);
  const [companyAllowAll, setCompanyAllowAll] = useState(true);
  const [selCompany, setSelCompany] = useState(COMPANY_ALL_VALUE);
  // const [selDep, setSelDep] = useState([]);

  const [radio, setRadio] = useState({
    tabs: '1', //1:詳細、3:3軸比較, 7:7軸比較
    radio01: 0, //詳細、役職選択、0:全体、1:役職選択
    radio02: 0, //詳細、性別選択、0:全体、1:男性、2:女性
    radio03: depAll, //詳細、部署選択、0:全体、1:部署選択
    radio04: 0, //詳細、年齢指定,0:全体、1:年齢指定
    radio05: 0, //詳細、等級選択、0:全体、1:等級選択
    radio06: 0, //詳細、出向状態選択、0:全体、1:出向状態選択
    radio07: 19, //詳細、終了年齢指定
    radio08: 75, //詳細、終了年齢指定
    radio11: 0, //比較選択１、役職選択、0:全体、1:一般職、2：管理職
    radio12: 0, //比較選択１、性別選択、0:全体、1:男性、2:女性
    radio13: 0, //比較選択１、部署選択、0:全体、1:部署選択
    radio21: 0, //比較選択2、役職選択、0:全体、1:一般職、2：管理職
    radio22: 0, //比較選択2、性別選択、0:全体、1:男性、2:女性
    radio23: 0, //比較選択2、部署選択、0:全体、1:部署選択
    radio31: 0, //比較選択3、役職選択、0:全体、1:一般職、2：管理職
    radio32: 0, //比較選択3、性別選択、0:全体、1:男性、2:女性
    radio33: 0, //比較選択3、部署選択、0:全体、1:部署選択
    department0: '', //詳細、選択部署Text
    department1: '', //比較選択１、選択部署Text
    department2: '', //比較選択１、選択部署Text
    department3: '', //比較選択１、選択部署Text
    department11: '', //比較選択7、選択部署Text
    department12: '', //比較選択7、選択部署Text
    department13: '', //比較選択7、選択部署Text
    department14: '', //比較選択7、選択部署Text
    department15: '', //比較選択7、選択部署Text
    department16: '', //比較選択7、選択部署Text
    department17: '', //比較選択7、選択部署Text
    position: '',
    levelCode: '',
    goOut: '',
  });

  const usr = useSelector((state) => state.user);

  const readDB = async () => {
    try {
      if (!usr.userData) return null;
      // console.log({ usr });
      setUserInfo(usr.userData);
      // const groupInfo = await Axios.get('api/group/');

      const [surveyInfo, groupInfo] = await Promise.all([
        Axios.get('/api/survey/'), //DBからサーベイ情報取得
        Axios.get('/api/group/30010'), //DBからグループ情報取得
        // Axios.get('/api/surveySeason/'), //DBからシーズン情報取得
        // Axios.get(config.USER_SERVER), //全てのユーザの習得（管理者以外）
      ]);
      if (usr.userData.groupCode === 'RECRNT' && usr.userData.role === 2) {
        const nonGroup = groupInfo.data.groups.filter(
          (item) => item.group_code !== 'RECRNT'
        );
        setGroups(nonGroup);
      } else {
        setGroups(groupInfo.data.groups);
      }
      // setGroups(groupInfo.data.groups);
      setSurvey(surveyInfo.data.survey);

      if (!groups) throw new Error('グループ取得に失敗しました。');
      if (!survey) throw new Error('サーベイ取得に失敗しました。');
      if (usr.userData.role === 3 || usr.userData.role === 7) {
        //企業管理者 (role 3) / シーズン指定管理者 (role 7)
        // onChangeGroup(usr.userData.groupCode);
        let sgi = groupInfo.data.groups.find(
          (item) => item.group_code === usr.userData.groupCode
        );
        // console.log({ sgi });
        if (sgi.has_affiliates === true) {
          // 系列会社ありグループ（Ph.4b）: role 7 の所属指定（e3_department）は「系列会社名／所属…」の
          // 会社修飾経路として解釈する。系列会社 Select の選択肢と部署範囲は下の loadCompanyChoices →
          // rebuildAffiliateTree で決める（従来の部分一致判定は使わない）
          setTreeData(genTree(sgi.department));
        } else if (
          // role 7 で所属指定 (e3_department) が設定されている場合のみ部署絞り込み
          usr.userData.role === 7 &&
          Array.isArray(usr.userData.e3Department) &&
          usr.userData.e3Department.filter((v) => v !== '').length > 0
        ) {
          // 空欄でない指定が 1 件以上あることは上の条件で保証済み → 常に部署を絞り込む。
          // ※ 旧実装は「'' の個数 < 10」で判定しており、所属指定が 10 件を超える配列
          //   （「部署指定拡張」PJ で最大 50 件化）では絞り込みが外れて全部署が閲覧できてしまうため廃止
          const d = Object.values(usr.userData.e3Department);
          let dd = [];
          for (let i = 0; i < d.length; i++) {
            if (d[i] !== '') {
              const ddd = sgi.department.filter((item) => item.includes(d[i]));
              dd = dd.concat(ddd);
            }
          }
          setDepAll(1);
          setTreeData(genTree2(sgi.department, dd));
          setSelTree(dd[0]);
          setRadio({
            ...radio,
            radio03: 1,
          });
        } else {
          setTreeData(genTree(sgi.department));
        }
        setSelGroupCode(usr.userData.groupCode);
        setSelGroupInfo(sgi);
        setGroupSurveySeasonInfo(
          filterAccessibleSeasons(sgi.survey_season, usr.userData, [
            '30010',
            '90301',
          ])
        );
        initGroup(usr.userData.groupCode, sgi);
        if (sgi.has_affiliates === true) {
          const company = await loadCompanyChoices(
            usr.userData.groupCode,
            sgi,
            toYmdDash(),
            COMPANY_ALL_VALUE
          );
          const nextDepAll = rebuildAffiliateTree(sgi.department, company);
          setRadio((prev) => ({ ...prev, radio03: nextDepAll }));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
    // console.log({ Users });
  }, [usr]);

  const initGroup = (value, sgi) => {
    // let sgi = groups.find((item) => item.group_code === value);
    // console.log({ groups });
    setSelGroupCode(value);
    setSelGroupInfo(sgi);
    setPositionArr(sgi.position);
    setLevelCodeArr(sgi.level_code);
    setGoOutArr(sgi.go_out);
    setRadio({
      ...radio,
      department11: '',
      department12: '',
      department13: '',
      department14: '',
      department15: '',
      department16: '',
      department17: '',
      radio03: depAll,
    });
    dpText = {
      dp1: '',
      dp2: '',
      dp3: '',
      dp4: '',
      dp5: '',
    };
    // setGroupSurveySeasonInfo(sgi.survey_season);
    dpObj = {
      dp1: [],
      dp2: [],
      dp3: [],
      dp4: [],
      dp5: [],
    };
    // setGroupSurveySeasonInfo(sgi.survey_season);
    const dp = [];
    for (let i = 0; i < sgi.department.length; i++) {
      if (sgi.department[i].split('／').length < 2) {
        dp.push(sgi.department[i]);
      }
    }

    for (let i = 0; i < sgi.department.length; i++) {
      let dArr = sgi.department[i].split('／');
      if (dArr.length === 1) {
        dpObj.dp1.push(sgi.department[i]);
      }
      if (dArr.length === 2) {
        dpObj.dp2.push(sgi.department[i]);
      }
      if (dArr.length === 3) {
        dpObj.dp3.push(sgi.department[i]);
      }
      if (dArr.length === 4) {
        dpObj.dp4.push(sgi.department[i]);
      }
      if (dArr.length === 5) {
        dpObj.dp5.push(sgi.department[i]);
      }
    }
    let selectArr = [];
    for (let i = 0; i < dpObj.dp1.length; i++) {
      const element = dpObj.dp1[i];
      selectArr.push(<Option key={element}>{element}</Option>);
    }

    // console.log(dpObj);
    const child = [];
    const dep = [];
    const childLong = [];
    const depLong = [];

    for (let i = 0; i < dp.length; i++) {
      const element = dp[i];
      child.push(<Option key={element}>{element}</Option>);
      dep.push(element);
    }
    for (let i = 0; i < sgi.department.length; i++) {
      const element = sgi.department[i];
      childLong.push(<Option key={element}>{element}</Option>);
      depLong.push(element);
    }
    setSelGroupDepartmentLong(childLong); //部署選択RadioのOption、Longバージョン
    setDepArrLong(depLong); //部署名の配列、Longバージョン
    setSelGroupDepartment(child); //部署選択RadioのOption、第一部署
    setDepArr(dep); //部署名の配列、第一部署
  };

  // 部署経路 → TreeSelect 用ツリー（共用ヘルパー。7 階層・親は経路の完全一致で解決）
  const genTree = (depArr) =>
    buildDepartmentTree(depArr, { icon: <CarryOutOutlined /> });
  // role 7 の所属指定: 許可経路（dd）以外を disabled にする（旧 genTree2 と同じ意味論）
  const genTree2 = (depArr, dd) =>
    buildDepartmentTree(depArr, {
      icon: <CarryOutOutlined />,
      enabledPaths: dd,
    });

  // ---- 系列会社 Select（「グループ会社・系列会社構造」PJ Ph.4b）----
  // 系列会社ありグループ（Group.has_affiliates === true）か
  const isAffiliate = !!selGroupInfo && selGroupInfo.has_affiliates === true;

  // role 7 の所属指定（e3_department）を会社修飾経路として解釈（role 7 以外は制限なし）
  const role7CompanyScope = () =>
    usr.userData && usr.userData.role === 7
      ? parseCompanyQualifiedPaths(usr.userData.e3Department)
      : { companies: null, scopes: null };

  // 系列会社の選択肢を読み込み、選択値を補正して返す。系列会社なしグループは API を呼ばず '' を返す。
  // role 7 は割り当てられた系列会社だけを選択肢にし、「全社（グループ全体）」は出さない（割り当てが全て空欄なら制限なし）
  const loadCompanyChoices = async (groupCode, sgi, dateStr, current) => {
    if (!sgi || sgi.has_affiliates !== true) {
      setCompanyNames([]);
      setCompanyAllowAll(true);
      setSelCompany(COMPANY_ALL_VALUE);
      return COMPANY_ALL_VALUE;
    }
    const rule = await resolveCompanyRule(groupCode, sgi, dateStr);
    const choices = companyChoices(rule.names, role7CompanyScope().companies);
    const next = normalizeCompanySelection(current, choices);
    setCompanyNames(choices.names);
    setCompanyAllowAll(choices.allowAll);
    setSelCompany(next);
    return next;
  };

  // 系列会社ありグループの部署ツリー再構築。role 7 は選択中の系列会社の割り当て経路（配下を含む）だけを選択可にし、
  // 先頭の経路を選択済みにする（会社全体の割り当て・role 7 以外は制限なし）。戻り値 = 部署選択の固定有無（depAll）
  const rebuildAffiliateTree = (paths, company) => {
    const src = Array.isArray(paths) ? paths : [];
    const scopePaths = companyScopePaths(role7CompanyScope(), company);
    if (scopePaths === null) {
      setDepAll(0);
      setTreeData(genTree(src));
      setSelTree('');
      return 0;
    }
    const dd = pathsWithinScopes(src, scopePaths);
    setDepAll(1);
    setTreeData(genTree2(src, dd));
    setSelTree(dd[0] || '');
    return 1;
  };

  // 系列会社の変更: 部署選択を初期化し、その系列会社の部署一覧でツリーを作り直す
  const onChangeCompany = async (value) => {
    const company = value || COMPANY_ALL_VALUE;
    setSelCompany(company);
    dpText = {
      dp1: '',
      dp2: '',
      dp3: '',
      dp4: '',
      dp5: '',
    };
    const nextDepAll = await applyOrgDepartmentSource(selSurveySeasonInfo, company);
    setRadio((prev) => ({ ...prev, radio03: nextDepAll, department0: '' }));
  };

  const onChangeGroup = (value) => {
    let sgi = groups.find((item) => item.group_code === value);
    // console.log({ groups });
    setTreeData(genTree(sgi.department));
    setSelTree('');
    setOrgNoticeDate(''); // 企業変更でシーズン未選択に戻るため組織表安内をクリア
    // 系列会社は企業変更で「全社」に戻す（系列会社ありグループのみ選択肢を取得）
    setSelCompany(COMPANY_ALL_VALUE);
    setCompanyNames([]);
    setCompanyAllowAll(true);
    loadCompanyChoices(value, sgi, toYmdDash(), COMPANY_ALL_VALUE);
    setSelGroupCode(value);
    setSelGroupInfo(sgi);
    setPositionArr(sgi.position);
    setLevelCodeArr(sgi.level_code);
    setGoOutArr(sgi.go_out);
    setRadio({
      ...radio,
      department11: '',
      department12: '',
      department13: '',
      department14: '',
      department15: '',
      department16: '',
      department17: '',
      radio03: depAll,
    });
    dpText = {
      dp1: '',
      dp2: '',
      dp3: '',
      dp4: '',
      dp5: '',
    };
    // setGroupSurveySeasonInfo(sgi.survey_season);
    dpObj = {
      dp1: [],
      dp2: [],
      dp3: [],
      dp4: [],
      dp5: [],
    };
    // setGroupSurveySeasonInfo(sgi.survey_season);
    const dp = [];
    for (let i = 0; i < sgi.department.length; i++) {
      if (sgi.department[i].split('／').length < 2) {
        dp.push(sgi.department[i]);
      }
    }

    for (let i = 0; i < sgi.department.length; i++) {
      let dArr = sgi.department[i].split('／');
      if (dArr.length === 1) {
        dpObj.dp1.push(sgi.department[i]);
      }
      if (dArr.length === 2) {
        dpObj.dp2.push(sgi.department[i]);
      }
      if (dArr.length === 3) {
        dpObj.dp3.push(sgi.department[i]);
      }
      if (dArr.length === 4) {
        dpObj.dp4.push(sgi.department[i]);
      }
      if (dArr.length === 5) {
        dpObj.dp5.push(sgi.department[i]);
      }
    }
    let selectArr = [];
    for (let i = 0; i < dpObj.dp1.length; i++) {
      const element = dpObj.dp1[i];
      selectArr.push(<Option key={element}>{element}</Option>);
    }

    // setDpState1(...dpState1, dpObj.dp1 )

    // console.log(dpObj);
    const child = [];
    const dep = [];
    const childLong = [];
    const depLong = [];

    for (let i = 0; i < dp.length; i++) {
      const element = dp[i];
      child.push(<Option key={element}>{element}</Option>);
      dep.push(element);
    }
    for (let i = 0; i < sgi.department.length; i++) {
      const element = sgi.department[i];
      childLong.push(<Option key={element}>{element}</Option>);
      depLong.push(element);
    }
    setSelGroupDepartmentLong(childLong); //部署選択RadioのOption、Longバージョン
    setDepArrLong(depLong); //部署名の配列、Longバージョン
    setSelGroupDepartment(child); //部署選択RadioのOption、第一部署
    setDepArr(dep); //部署名の配列、第一部署

    setGroupSurveySeasonInfo(
      filterAccessibleSeasons(sgi.survey_season, usr.userData, [
        '30010',
        '90301',
      ])
    );
    setSelSurveySeasonId('');
    setSelQuestionSetId('');
    setQuestionSet([]);
  };

  // Date → 'YYYY-MM-DD'（組織表 API の date パラメータ・安内表示用）
  const ymdDash = (tdate) => {
    const date = new Date(tdate);
    return (
      date.getFullYear() +
      '-' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + date.getDate()).slice(-2)
    );
  };

  // 部署経路配列（Group.department または組織表由来）から treeData / selTree を再構築。
  // readDB の role3/7 分岐と同じ意味論を org モードでも再現する。
  // 戻り値 = 部署選択の固定有無（depAll）。系列会社なしグループは従来どおり現在の depAll を返す
  const rebuildTree = (paths, company) => {
    const src = Array.isArray(paths) ? paths : [];
    if (isAffiliate) return rebuildAffiliateTree(src, company);
    // role 7 で所属指定（depAll=1）の場合は genTree2 + dd[0] 選択を再現
    if (
      userInfo.role === 7 &&
      depAll === 1 &&
      usr.userData &&
      Array.isArray(usr.userData.e3Department)
    ) {
      const d = Object.values(usr.userData.e3Department);
      let dd = [];
      for (let i = 0; i < d.length; i++) {
        if (d[i] !== '') {
          // 現行 readDB L159 と同じ substring 意味論
          dd = dd.concat(src.filter((item) => item.includes(d[i])));
        }
      }
      setTreeData(genTree2(src, dd));
      setSelTree(dd[0] || '');
    } else {
      setTreeData(genTree(src));
      setSelTree('');
    }
    return depAll;
  };

  // 選択シーズンの開始日時点で有効な確定組織表があれば部署ソースをそれに切替、
  // 無ければ Group.department（従来）へフォールバック。安内表示も更新する。
  // 系列会社ありグループ（Ph.4b）は company（'' = 全社）の系列会社配下の部署に絞り、組織表が無ければ
  // ユーザーの所属から導出した部署一覧を使う（fetchDeptPathsForCompany）。戻り値 = depAll
  const applyOrgDepartmentSource = async (sssi, company) => {
    let paths = (selGroupInfo && selGroupInfo.department) || [];
    let orgActive = false;
    if (sssi && sssi.survey_start_date) {
      const dateStr = ymdDash(sssi.survey_start_date);
      const result = await fetchDeptPathsForCompany(selGroupCode, company, dateStr, {
        affiliate: isAffiliate,
      });
      if (result) {
        paths = result.paths;
        if (result.source === 'org') {
          orgActive = true;
          setOrgNoticeDate(dateStr);
        }
      }
    }
    if (!orgActive) setOrgNoticeDate('');
    return rebuildTree(paths, company);
  };

  const onChangeSurveySeason = async (value) => {
    const sssi = groupSurveySeasonInfo.find((item) => item._id === value); //selSurveySeasonInfo
    setSelSurveySeasonId(value);
    setSelSurveySeasonInfo(sssi);

    // 系列会社ありグループはシーズン開始日時点の系列会社一覧で選択肢を更新（無い会社なら全社等へ補正）
    const company = await loadCompanyChoices(
      selGroupCode,
      selGroupInfo,
      toYmdDash(sssi && sssi.survey_start_date),
      selCompany
    );
    // シーズン変更で部署ソース（確定組織表 or Group.department）を切替・選択値を初期化
    const nextDepAll = await applyOrgDepartmentSource(sssi, company);

    setRadio({
      tabs: '1', //1:詳細、3:3軸比較, 7:7軸比較
      radio01: 0, //詳細、役職選択、0:全体、1:役職選択
      radio02: 0, //詳細、性別選択、0:全体、1:男性、2:女性
      radio03: nextDepAll, //詳細、部署選択、0:全体、1:部署選択
      radio04: 0, //詳細、年齢指定,0:全体、1:年齢指定
      radio05: 0, //詳細、等級選択、0:全体、1:等級選択
      radio06: 0, //詳細、出向状態選択、0:全体、1:出向状態選択
      radio07: 19, //詳細、終了年齢指定
      radio08: 75, //詳細、終了年齢指定
      radio11: 0, //比較選択１、役職選択、0:全体、1:一般職、2：管理職
      radio12: 0, //比較選択１、性別選択、0:全体、1:男性、2:女性
      radio13: 0, //比較選択１、部署選択、0:全体、1:部署選択
      radio21: 0, //比較選択2、役職選択、0:全体、1:一般職、2：管理職
      radio22: 0, //比較選択2、性別選択、0:全体、1:男性、2:女性
      radio23: 0, //比較選択2、部署選択、0:全体、1:部署選択
      radio31: 0, //比較選択3、役職選択、0:全体、1:一般職、2：管理職
      radio32: 0, //比較選択3、性別選択、0:全体、1:男性、2:女性
      radio33: 0, //比較選択3、部署選択、0:全体、1:部署選択
      department0: '', //詳細、選択部署Text
      department1: '', //比較選択１、選択部署Text
      department2: '', //比較選択１、選択部署Text
      department3: '', //比較選択１、選択部署Text
      department11: '', //比較選択7、選択部署Text
      department12: '', //比較選択7、選択部署Text
      department13: '', //比較選択7、選択部署Text
      department14: '', //比較選択7、選択部署Text
      department15: '', //比較選択7、選択部署Text
      department16: '', //比較選択7、選択部署Text
      department17: '', //比較選択7、選択部署Text
      position: '',
      levelCode: '',
      goOut: '',
    });

    // console.log({ sssi });
    const ssi = survey.find((item) => item._id === sssi.survey_id);
    setSelSurveyInfo(ssi);
    setQuestionSet(sssi.question_set);
    if (sssi.question_set.length > 0) {
      setSelQuestionSetId(sssi.question_set[0]._id);
    } else {
      setSelQuestionSetId('');
    }
    // console.log({ selQuestionSetId });
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      // console.log({ radio });
      setIsModalVisible(true);
      setSubmitSW(false);
      if (radio.tabs === '7') {
        const dp = [];
        if (radio.department11) dp.push(radio.department11);
        if (radio.department12) dp.push(radio.department12);
        if (radio.department13) dp.push(radio.department13);
        if (radio.department14) dp.push(radio.department14);
        if (radio.department15) dp.push(radio.department15);
        if (radio.department16) dp.push(radio.department16);
        if (radio.department17) dp.push(radio.department17);
        if (dp.length < 3) {
          throw new Error('部署を３個以上指定してください。');
        }
      }
      let sendData = {};
      if (radio.tabs === '1') {
        let dText = '';
        // console.log({ dpText });
        if (dpText.dp1) {
          dText = dpText.dp1;
        }
        if (dpText.dp2) {
          dText = `${dText}／${dpText.dp2}`;
        }
        if (dpText.dp3) {
          dText = `${dText}／${dpText.dp3}`;
        }
        if (dpText.dp4) {
          dText = `${dText}／${dpText.dp4}`;
        }
        if (dpText.dp5) {
          dText = `${dText}／${dpText.dp5}`;
        }
        // console.log({ radio });
        // console.log({ depAll });

        sendData = {
          selGroupInfo: selGroupInfo,
          selSurveySeasonInfo: selSurveySeasonInfo,
          // 系列会社ありグループのみ company（'' = 全社）を送る（系列会社なしグループは従来どおりキー無し）
          searchInfo: isAffiliate
            ? { ...radio, department0: selTree, company: selCompany }
            : { ...radio, department0: selTree },
          userInfo: userInfo,
        };
      } else {
        sendData = {
          selGroupInfo: selGroupInfo,
          selSurveySeasonInfo: selSurveySeasonInfo,
          searchInfo: radio,
        };
      }
      // console.log({ sendData });
      const res = await Axios.post('/api/dbModel100/makeReport30010', sendData);
      // サーバープロキシ経由でPDFを表示（S3 URLを露出しない）
      message.success({
        content: 'ファイル生成完了！',
        key: 'makecsv',
        duration: 2,
      });
      setSubmitSW(true);
      setIsModalVisible(false);
      openReport(res.data.tokenId);
    } catch (error) {
      console.log(error.message);
      setIsModalVisible(false);
      // サーバーが返したメッセージ（「対象者がありません。」「回答データがありません。」等）を優先し、無ければ従来の固定文言
      const serverMessage =
        error.response && error.response.data && error.response.data.error;
      message.error({
        content:
          typeof serverMessage === 'string' && serverMessage
            ? serverMessage
            : '対象者が少ないため相関関係の計算ができません。',
        key: 'makecsv',
        duration: 5,
      });

      setSelTree('');
      setRadio({
        tabs: '1', //1:詳細、3:3軸比較, 7:7軸比較
        radio01: 0, //詳細、役職選択、0:全体、1:役職選択
        radio02: 0, //詳細、性別選択、0:全体、1:男性、2:女性
        radio03: depAll, //詳細、部署選択、0:全体、1:部署選択
        radio04: 0, //詳細、年齢指定,0:全体、1:年齢指定
        radio05: 0, //詳細、等級選択、0:全体、1:等級選択
        radio06: 0, //詳細、出向状態選択、0:全体、1:出向状態選択
        radio07: 19, //詳細、終了年齢指定
        radio08: 75, //詳細、終了年齢指定
        radio11: 0, //比較選択１、役職選択、0:全体、1:一般職、2：管理職
        radio12: 0, //比較選択１、性別選択、0:全体、1:男性、2:女性
        radio13: 0, //比較選択１、部署選択、0:全体、1:部署選択
        radio21: 0, //比較選択2、役職選択、0:全体、1:一般職、2：管理職
        radio22: 0, //比較選択2、性別選択、0:全体、1:男性、2:女性
        radio23: 0, //比較選択2、部署選択、0:全体、1:部署選択
        radio31: 0, //比較選択3、役職選択、0:全体、1:一般職、2：管理職
        radio32: 0, //比較選択3、性別選択、0:全体、1:男性、2:女性
        radio33: 0, //比較選択3、部署選択、0:全体、1:部署選択
        department0: '', //詳細、選択部署Text
        department1: '', //比較選択１、選択部署Text
        department2: '', //比較選択１、選択部署Text
        department3: '', //比較選択１、選択部署Text
        department11: '', //比較選択7、選択部署Text
        department12: '', //比較選択7、選択部署Text
        department13: '', //比較選択7、選択部署Text
        department14: '', //比較選択7、選択部署Text
        department15: '', //比較選択7、選択部署Text
        department16: '', //比較選択7、選択部署Text
        department17: '', //比較選択7、選択部署Text
        position: '',
        levelCode: '',
        goOut: '',
      });
    }
  };
  const onChangeTabs = async (key) => {
    // console.log('Tabbed', key);
    setRadio({ ...radio, tabs: key });
  };
  const onChangeRadio01 = async (e) => {
    // console.log('radio01 checked', e.target.value);
    setRadio({ ...radio, radio01: e.target.value });
  };
  const onChangeRadio02 = async (e) => {
    // console.log('radio02 checked', e.target.value);
    setRadio({ ...radio, radio02: e.target.value });
  };
  const onChangeRadio03 = async (e) => {
    // console.log('radio03 checked', e.target.value);
    if (e.target.value === 0) {
      setRadio({
        ...radio,
        radio03: e.target.value,
      });
      setSelTree('');
      dpText = {
        dp1: '',
        dp2: '',
        dp3: '',
        dp4: '',
        dp5: '',
      };
    } else {
      setRadio({ ...radio, radio03: e.target.value });
    }
  };
  const onChangeRadio04 = async (e) => {
    //年齢Option
    // console.log('radio13 checked', e.target.value);
    setRadio({ ...radio, radio04: e.target.value });
  };
  const onChangeRadio07 = async (e) => {
    //開始年代
    // console.log('radio13 checked', e.target.value);
    setRadio({ ...radio, radio07: e.target.value });
  };
  const onChangeRadio08 = async (e) => {
    //終了年代
    // console.log('radio13 checked', e.target.value);
    setRadio({ ...radio, radio08: e.target.value });
  };
  const onChangeRadio05 = async (e) => {
    //等級
    // console.log('radio13 checked', e.target.value);
    setRadio({ ...radio, radio05: e.target.value });
  };
  const onChangeRadio06 = async (e) => {
    //出向状態
    // console.log('radio13 checked', e.target.value);
    setRadio({ ...radio, radio06: e.target.value });
  };

  const onChangePosition = async (value) => {
    // console.log('Selected', value);
    setRadio({ ...radio, position: value });
  };
  const onChangeLevelCode = async (value) => {
    // console.log('Selected', value);
    setRadio({ ...radio, levelCode: value });
  };
  const onChangeGoOut = async (value) => {
    // console.log('Selected', value);
    setRadio({ ...radio, goOut: value });
  };

  const handleChangeTree0 = (value, label, extra) => {
    // console.log({ value });
    setSelTree(value);
    if (value) {
      setRadio({
        ...radio,
        radio03: 1,
      });
    } else {
      setRadio({
        ...radio,
        radio03: 0,
      });
    }
  };

  return (
    <Fragment>
      <div style={{ maxWidth: '1100px', margin: '2rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2}>E³-Survey結果ダウンロード(PDF)</Title>
        </div>
        <Form onSubmit={onSubmit}>
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❶</Title>
          {(userInfo.role === 9 || userInfo.role === 2) && (
            <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>企業を選択してください。（必須）</Text>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Select
              showSearch
              style={{ marginLeft: 0, marginRight: 10, width: 300 }}
              placeholder="企業選択"
              optionFilterProp="children"
              onChange={onChangeGroup}
              value={selGroupCode}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              disabled={userInfo.role === 3 || userInfo.role === 7}
            >
              {groups.map((element) => {
                // console.log({ element });
                return (
                  <Option value={element.group_code} key={element._id}>
                    {element.group_name}
                  </Option>
                );
              })}
            </Select>
          </div>
          <br />
          <div>
            <Title style={{ color: 'var(--brand-primary)' }}>❷</Title>
            <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>サーベイを選択してください。（必須）</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Select
                showSearch
                style={{ marginLeft: 0, marginRight: 5, width: 400 }}
                placeholder="シーズン選択"
                optionFilterProp="children"
                onChange={onChangeSurveySeason}
                value={selSurveySeasonId}
                disabled={groupSurveySeasonInfo.length === 0}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {groupSurveySeasonInfo.map((element) => {
                  // console.log({ element });
                  return (
                    <Option value={element._id} key={element._id}>
                      {element.season_name}
                    </Option>
                  );
                })}
              </Select>
            </div>
            {selGroupCode && groupSurveySeasonInfo.length === 0 && (
              <Text type="danger" style={{ display: 'block', marginTop: 6 }}>
                {noAccessibleSeasonMessage(userInfo)}
              </Text>
            )}
          </div>
          {isAffiliate && (
            <CompanySelectBlock
              names={companyNames}
              allowAll={companyAllowAll}
              value={selCompany}
              onChange={onChangeCompany}
            />
          )}
          <br />
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❸</Title>
          {/* <Text strong>結果フォーマットを選択してください。（必須）</Text> */}
          <Tabs
            onChange={onChangeTabs}
            size="large"
            style={{ marginBottom: 30 }}
            items={[
              {
                key: '1',
                label: 'E³-Survey詳細結果',
                children: (
                  <>
              <Card
                type="inner"
                style={{ marginTop: 16, width: 350 }}
                title="役職選択"
              >
                <Radio.Group onChange={onChangeRadio01} value={radio.radio01}>
                  <Space direction="vertical">
                    <Radio value={0}>全体（選択クリア）</Radio>
                    {/* <Radio value={1}>一般職クラス</Radio>
                    <Radio value={2}>管理職クラス</Radio> */}
                    <Radio value={1}>
                      役職選択 ▶︎
                      {radio.radio01 === 1 ? (
                        <CheckboxMenu
                          options={positionArr}
                          value={[]}
                          onChange={onChangePosition}
                        />
                      ) : null}
                    </Radio>
                  </Space>
                </Radio.Group>
              </Card>
              <Card
                type="inner"
                style={{ marginTop: 16, width: 350 }}
                title="等級選択"
              >
                <Radio.Group onChange={onChangeRadio05} value={radio.radio05}>
                  <Space direction="vertical">
                    <Radio value={0}>全体（選択クリア）</Radio>
                    {/* <Radio value={1}>一般職クラス</Radio>
                    <Radio value={2}>管理職クラス</Radio> */}
                    <Radio value={1}>
                      等級選択 ▶︎
                      {radio.radio05 === 1 ? (
                        <CheckboxMenu
                          options={levelCodeArr}
                          value={[]}
                          onChange={onChangeLevelCode}
                        />
                      ) : null}
                    </Radio>
                  </Space>
                </Radio.Group>
              </Card>
              <Card
                type="inner"
                style={{ marginTop: 16, width: 350 }}
                title="出向状態選択"
              >
                <Radio.Group onChange={onChangeRadio06} value={radio.radio06}>
                  <Space direction="vertical">
                    <Radio value={0}>全体（選択クリア）</Radio>
                    <Radio value={1}>
                      出向状態選択 ▶︎
                      {radio.radio06 === 1 ? (
                        <CheckboxMenu
                          options={goOutArr}
                          value={[]}
                          onChange={onChangeGoOut}
                        />
                      ) : null}
                    </Radio>
                  </Space>
                </Radio.Group>
              </Card>
              <Card
                type="inner"
                style={{ marginTop: 16, width: 350 }}
                title="性別選択"
              >
                <Radio.Group onChange={onChangeRadio02} value={radio.radio02}>
                  <Space direction="vertical">
                    <Radio value={0}>全体</Radio>
                    <Radio value={1}>男性</Radio>
                    <Radio value={2}>女性</Radio>
                  </Space>
                </Radio.Group>
              </Card>
              <Card
                title="年代選択"
                type="inner"
                style={{ marginTop: 16, width: 350 }}
              >
                <Radio.Group onChange={onChangeRadio04} value={radio.radio04}>
                  <Space direction="vertical">
                    <Radio value={0}>全体</Radio>
                    <Radio value={1}>年齢指定</Radio>
                  </Space>
                </Radio.Group>
                <br />
                <Input
                  style={{ marginTop: 16, width: 80 }}
                  placeholder="年齢"
                  name="startAge"
                  allowClear
                  onChange={onChangeRadio07}
                  value={radio.radio07}
                  disabled={radio.radio04 !== 1}
                />
                　歳　〜　
                <Input
                  style={{ width: 80 }}
                  placeholder="年齢"
                  name="endAge"
                  allowClear
                  onChange={onChangeRadio08}
                  value={radio.radio08}
                  disabled={radio.radio04 !== 1}
                />
                　歳
              </Card>
              <Card
                type="inner"
                style={{ marginTop: 16, width: 700 }}
                title="部署選択"
                extra={
                  <Button
                    size="small"
                    onClick={(e) => handleChangeTree0('', null, null)}
                    disabled={!selTree || depAll}
                  >
                    選択クリア
                  </Button>
                }
              >
                <Space direction="vertical">
                  {orgNoticeDate && (
                    <Text type="secondary">
                      組織情報管理の確定組織表（{orgNoticeDate} 時点）の部署一覧を表示しています
                    </Text>
                  )}
                  <Text>部署選択 ▶︎ {selTree ? selTree : '全部署'} </Text>
                  <TreeSelect
                    {...DEPT_TREE_SELECT_PROPS}
                    style={{ width: '100%', maxWidth: 800 }}
                    treeData={treeData}
                    onSelect={handleChangeTree0}
                    value={selTree}
                  />
                </Space>
              </Card>
                  </>
                ),
              },
            ]}
          />
          <Title style={{ color: 'var(--brand-primary)' }}>❹</Title>
          <Button
            type="default" className="ds-btn-secondary"
            size="large"
            onClick={onSubmit}
            disabled={!(submitSW && selSurveySeasonId)}
          >
            ダウンロード
          </Button>
        </Form>
      </div>
      <Modal
        title="サーベイ結果ファイル生成中..."
        open={isModalVisible}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: true }}
        styles={{ body: { textAlign: 'center' } }}
      >
        <Spin size="large" />
      </Modal>
    </Fragment>
  );
};

export default PDF30010DowlnoadPage;
